import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Link } from 'react-router-dom';
import './Common.scss';

interface NaviMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const NaviMenu: React.FC<NaviMenuProps> = ({ isOpen, onClose }) => {
  const { authData, logout } = useAuth();

  return (
    <div>
      {authData.token ? (
        <div className={`overlay navi-menu ${isOpen ? 'open' : ''}`}>
          <nav className="overlay-menu">
            <ul>
              <li>
                <Link to="/" onClick={onClose}>
                  Top
                </Link>
              </li>
              <li>
                <Link to="/reserve" onClick={onClose}>
                  Reserve
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={onClose}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/admin" onClick={onClose}>
                  Admin
                </Link>
              </li>
              <li>
                <span
                  className="text-white"
                  onClick={() => {
                    logout();
                    onClose();
                  }}
                >
                  Logout
                </span>
              </li>
            </ul>
          </nav>
        </div>
      ) : (
        <div className={`overlay navi-menu ${isOpen ? 'open' : ''}`}>
          <nav className="overlay-menu">
            <ul>
              <li>
                <Link to="/" onClick={onClose}>
                  Top
                </Link>
              </li>
              <li>
                <Link to="/reserve" onClick={onClose}>
                  Reserve
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={onClose}>
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default NaviMenu;
